import * as React from "react";
import { CountDownBox, Time } from "./styled";
import Icon from "../../../../../../components/MyIcon";
import { px2rem } from "../../../../../utils/css";
const CountDown = (props) => {
    const { countTime, style, needIcon = true } = props;
    const [endTime, setEndTime] = React.useState(+countTime);
    const formatTime = (t) => {
        if (t <= 0) {
            return "00";
        }
        return t > 9 ? `${t}` : `0${t}`;
    };
    const formatSecToDate = (t) => {
        const hour = formatTime(Math.floor(t / 3600));
        const min = formatTime(Math.floor((t / 60) % 60));
        const sec = formatTime(Math.floor(t % 60));
        return `Ends in ${hour}:${min}:${sec}`;
    };
    const tick = () => {
        setEndTime(preTime => {
            return preTime - 1;
        });
    };
    React.useEffect(() => {
        let timerID = setInterval(() => {
            if (endTime > 0) {
                tick();
            }
        }, 1000);
        return () => clearInterval(timerID);
    });
    if (endTime <= 0) {
        return null;
    }
    return (React.createElement(CountDownBox, { style: Object.assign({}, style) },
        needIcon && (React.createElement(Icon, { style: { color: "pink" }, type: "flashsaleicon", size: px2rem(12), color: "#fff" })),
        React.createElement(Time, null, formatSecToDate(endTime))));
};
export default CountDown;
